interface PropertiesSummaryBarProps {
  totalProperties: number;
  metersConfigured: number;
  activeAlarms: number;
}

export function PropertiesSummaryBar({
  totalProperties,
  metersConfigured,
  activeAlarms,
}: PropertiesSummaryBarProps) {
  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden">
      <div className="grid grid-cols-3 divide-x divide-gray-200 dark:divide-gray-700">
        <div className="p-4 sm:p-6 text-center">
          <p className="text-xs sm:text-sm font-medium text-gray-500 dark:text-gray-400">Total Properties</p>
          <p className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100 mt-1">{totalProperties}</p>
        </div>
        <div className="p-4 sm:p-6 text-center">
          <p className="text-xs sm:text-sm font-medium text-gray-500 dark:text-gray-400">Meters Configured</p>
          <p className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100 mt-1">{metersConfigured}</p>
        </div>
        <div className="p-4 sm:p-6 text-center">
          <p className="text-xs sm:text-sm font-medium text-gray-500 dark:text-gray-400">Active Alerts</p>
          <p className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100 mt-1">{activeAlarms}</p>
        </div>
      </div>
    </div>
  );
}
